import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/useAuth';

const WELCOME_SEEN_KEY = '@citizenly_welcome_seen';
const ONBOARDED_KEY = (userId: string) => `@citizenly_onboarded_${userId}`;

export function useOnboarding() {
  const { user, profile, isAuthLoading, isProfileLoading } = useAuth();
  const [hasSeenWelcome, setHasSeenWelcome] = useState(
    () => localStorage.getItem(WELCOME_SEEN_KEY) === 'true'
  );

  const markWelcomeSeen = useCallback(() => {
    localStorage.setItem(WELCOME_SEEN_KEY, 'true');
    setHasSeenWelcome(true);
  }, []);

  const resetWelcome = useCallback(() => {
    localStorage.removeItem(WELCOME_SEEN_KEY);
    setHasSeenWelcome(false);
  }, []);

  const profileCompleted = !!profile?.full_name;

  useEffect(() => {
    if (user?.id && profileCompleted) {
      localStorage.setItem(ONBOARDED_KEY(user.id), 'true');
    }
  }, [user?.id, profileCompleted]);

  const cachedCompleted =
    !!user?.id && localStorage.getItem(ONBOARDED_KEY(user.id)) === 'true';

  const hasCompletedOnboarding = profileCompleted || cachedCompleted;
  const isLoading = isAuthLoading || isProfileLoading;
  const needsOnboarding = !isLoading && !!profile && !hasCompletedOnboarding;

  return {
    isLoading,
    hasSeenWelcome,
    hasCompletedOnboarding,
    needsOnboarding,
    markWelcomeSeen,
    resetWelcome,
  };
}
